module.exports = __webpack_public_path__ + "media/new/ext-link-hover-4dcc8bd4.svg";